






























































import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import * as $ from 'jquery';
import DataTableNet from 'datatables.net';
import 'datatables.net-bs4';
import 'datatables.net-responsive';
import '../../public/uikitjs/DataTablesExtJS';
import { AudienceSearchFilter } from '../models/AudienceSearchFilter';
import { AudienceSearchEditConfirm } from '../models/AudienceSearchEditConfirm';
import { StatisticsPanelModel } from '../models/StatisticsPanelModel';
import AudienceSearchEditConfirmModal from '@/components/AudienceSearchEditConfirmModal.vue';
import {
    GenericModal,
    GenericModalType,
    GenericModalCancelLabel,
    GenericModalContinueLabel,
    GenericModalTitle,
    GenericModalOption,
    GenericModalResponse
} from '../models/GenericModal';
import AudienceGenericModal from '@/components/AudienceGenericModal.vue';
import { Action, Getter } from 'vuex-class';
import StatisticsPanel from '@/components/StatisticsPanel.vue';
import Common from '../helper/Common';
import { AudienceDetailsService } from '../services/AudienceDetailsService';
import BaseView from '../BaseView';
import { systemTimezone } from '../constants/general';

interface CountColumnModel {
    spanElement: any;
    hiddenElement: any;
    requestId: number;
    detailId: number;
    count: any;
}

interface AudienceAction {
    audienceId: number;
}

interface AudienceActivation extends AudienceAction {
    // audienceId: number;
    status: boolean;
    rowNumber: number;
    campaignsCount: number;
}

@Component({
    components: {
        DataTableNet,
        AudienceSearchEditConfirmModal,
        AudienceGenericModal,
        StatisticsPanel
    }
})
export default class AudienceSearchResults extends BaseView {

    @Prop(Number) public clientId!: number;
    @Prop({}) public externalSearchFilters!: AudienceSearchFilter[];

    @Prop(Boolean) public isSelectable!: boolean;
    @Prop(Number) public selectedAudienceID!: number;

    public searchFilters: AudienceSearchFilter[] = [];

    private audienceSearchTable: any;

    private UseCacheIfExists: boolean = true;

    @Getter('SearchResultTableCache', { namespace: 'manageAudience' })
    private SearchResultTableCache!: any;

    @Action('setSearchResultTableCache', {  namespace: 'manageAudience'  })
    private setSearchResultTableCache: any;

    @Getter('SearchResultTableStateCache', { namespace: 'manageAudience' })
    private SearchResultTableStateCache!: any;

    @Action('setSearchResultTableStateCache', {  namespace: 'manageAudience'  })
    private setSearchResultTableStateCache: any;

    @Watch('externalSearchFilters', { deep: true })
    public onExternalSearchFilterUpdated(value: AudienceSearchFilter[] ) {
        // update search filter with the externalSearchFilters value
        this.searchFilters = value;
        // force datatable to go fetch data based on updated search filter
        if ($.fn.DataTable.isDataTable('#tableAudienceSearchResult')) {
            this.UseCacheIfExists = false;
            if (
                value.length === 2 &&
                value[0].Field === 'isActive' &&
                value[0].Operator === 'equals' &&
                value[0].Value === true &&
                value[1].Field === 'audienceDetailType') {
                this.audienceSearchTable.draw().order( [[ 4, 'desc' ]] );
            }
            this.audienceSearchTable.ajax.reload();
        } else {
            this.InitAudienceSearchTable();
        }
    }

    public onEditLastPublished(audienceId: number, detailId: number): void {
        // check if the user can modify this audience
        window.App.$axios.get(`/api/audience/api/v1.0/companyid/${this.clientId}/audience/${audienceId}/details/${detailId}/access-type?api_user=${window.eInsightUserEmail}`)
            .then((response) => {
                switch (response.data.data) {
                    case 0: // full access
                        // go through the audience details versions comparison
                        const this$: any = $;
                        const path: string = `/api/audience/api/v1.0/companyid/${this.clientId}/audience/${audienceId}/compare?api_user=${window.eInsightUserEmail}`;
                        window.App.$axios.get(path)
                            .then((response) => {
                                if (response.data.data.sameAsLastSaved) {
                                    const returnURL = encodeURI(this.$router.currentRoute.fullPath);
                                    this
                                        .$router
                                        .push(`/audience/${audienceId}/edit/${detailId}?returnURL=${returnURL}`);
                                } else {
                                    const editing: AudienceSearchEditConfirm = new AudienceSearchEditConfirm();
                                    //editing.LastSavedUpdateDate = new Date(response.data.data.lastSavedUpdateDate).toLocaleString(window.eInsightUserRegion);
                                    editing.LastSavedUpdateDate = Common.formatDate(response.data.data.lastSavedUpdateDate) + ' ' + Common.formatTime(response.data.data.lastSavedUpdateDate);
                                    editing.LastSavedUser = response.data.data.lastSavedUpdatedBy;
                                    //editing.LastPublishedUpdateDate = new Date(response.data.data.lastPublishedUpdateDate).toLocaleString(window.eInsightUserRegion);
                                    editing.LastPublishedUpdateDate = Common.formatDate(response.data.data.lastPublishedUpdateDate) + ' ' + Common.formatTime(response.data.data.lastPublishedUpdateDate);
                                    editing.LastPublishedUser = response.data.data.lastPublishedUpdatedBy;
                                    editing.AudienceId = Number(audienceId);
                                    editing.DetailId = Number(detailId);
                                    const refedit: any = this.$refs.editModalRef;
                                    refedit.showEditConfirmModal(editing);
                                }
                            });
                        break;
                    case 1: // read only
                        // simply open the audience details in read-only mode
                        const returnURL = encodeURI(this.$router.currentRoute.fullPath);
                        this.$router.push(`/audience/${audienceId}/edit/${detailId}?returnURL=${returnURL}`);
                        break;
                    case 2: // no access
                        break;
                }
            });
    }

    private showModal(request: GenericModal) {
        const modal: any = this.$refs.genericModalref;
        modal.show(request);
    }

    private hideModal() {
        const modal: any = this.$refs.genericModalref;
        modal.hide();
    }

    private handleContinuePopup(response: GenericModalResponse) {
        switch (response.id) {
            case 'GeneratingCounts': {
                break;
            }
            case 'AudineceActivation': {
                this.handleContinueAudienceActivation(response.requested);
                break;
            }
            case 'ViewCampaigns': {
                this.handleViewCampaigns(response.requested);
                break;
            }
            default: {
                break;
            }
        }
    }

    private handleCancelPopup(response: GenericModalResponse) {
        switch (response.id) {
            case 'AudineceActivation': {
                this.handleCancelAudienceActivation(response.requested);
                break;
            }
            default: {
                break;
            }
        }
    }

    private handleContinueAudienceActivation(request: AudienceActivation) {
        this.activateDeactivateAudience(request);
    }

    private handleViewCampaigns(request: AudienceAction) {
        this.hideModal();
        this.$router.push(`audience/${request.audienceId}/detail/LastPublished?campaigns=1`);
    }

    private handleCancelAudienceActivation(request: AudienceActivation) {
        $(`#audience_status${request.audienceId}`).prop('disabled', false);
        $(`#audience_status${request.audienceId}`).prop('checked', !$(`#audience_status${request.audienceId}`).prop('checked'));
    }

    private activateDeactivateAudienceClicked(request: AudienceActivation, audienceName: string) {

        if (request.status) {
            this.activateDeactivateAudience(request);
        } else {
            const options: GenericModal = new GenericModal();
            options.requesting = request;

            if (request.campaignsCount > 0) {
                options.id = 'ViewCampaigns';
                options.cancelButton = GenericModalCancelLabel.Close;
                options.continueButton = GenericModalContinueLabel.ViewCampaigns;
                options.message = `To deactivate this audience, please remove it from all associated campaigns`;
                options.title = GenericModalTitle.Warning;
            } else {
                options.id = 'AudineceActivation';
                options.cancelButton = GenericModalCancelLabel.Cancel;
                options.continueButton = GenericModalContinueLabel.Deactivate;
                options.message = `Deactivate ${audienceName}?`;
                options.title = GenericModalTitle.Confirm;
            }
            this.showModal(options);
        }
    }

    private activateDeactivateAudience(request: AudienceActivation) {
        const that: any = this;
        const service: AudienceDetailsService = new AudienceDetailsService(this.clientId);
        service
            .ActivateDeactivateAudience(request.audienceId, request.status)
            .then((response) => {
                switch (response.data.data.status) {
                    case 'Activated':
                        that.audienceSearchTable
                            .row(request.rowNumber)
                            .data()
                            .isActive = true;
                        break;
                    case 'Deactivated':
                        that.audienceSearchTable
                            .row(request.rowNumber)
                            .data()
                            .isActive = false;

                        if (that.searchingInactiveAudiences()) {
                            that.audienceSearchTable
                                .row(request.rowNumber)
                                .remove();
                        }

                        this.hideModal();
                        break;
                    default:

                        console.log('activateDeactivateAudience response DEFAULT: ', response);
                        break;
                }
            })
            .finally(() => {
                that.audienceSearchTable
                    .row()
                    .draw();
            });
    }

    private searchingInactiveAudiences(): boolean {
        let searchingInactives: boolean = true;
        this.searchFilters.forEach((i) => {
            if (i.Field === 'isActive' && i.Value === true) {
                searchingInactives = false;
            }
        });
        return searchingInactives;
    }

    // update row Count value
    private onStatisticsGenerating(data: any): void {
        const detail: CountColumnModel = {
            spanElement: $(`.count_${data.detailId}`),
            hiddenElement: $(`#statisticsRequest${data.detailId}`),
            requestId: data.requestId,
            detailId: data.detailId,
            count: -1,
        };

        const previous: string = detail.spanElement.attr('data-count-previous');
        const current: string = detail.spanElement.text();
        if (current !== 'Generating') {
            $(detail.spanElement).attr('data-count-previous', current);
        }

        // update count to generating...
        detail.spanElement.text('Generating');
        // set statistics requestId for audinece
        detail.hiddenElement.val(detail.requestId);

        // Update the data status attribue to reflact the status
        // move previous status to a temp location in order to handle cancel later.
        if (detail.hiddenElement.attr('data-count-status') !== '') {
            detail.hiddenElement.attr('data-count-status-previous', detail.hiddenElement.attr('data-count-status'));
            // Empty the current status which is only used by "NOCOUNTS" situation
            detail.hiddenElement.attr('data-count-status', '');
        }

    }

    // update row Count value
    private onStatisticsCompleted(data: any): void {
        const detail: CountColumnModel = {
            spanElement: $(`.count_${data.detailId}`),
            hiddenElement: $(`#statisticsRequest${data.detailId}`),
            requestId: -1,
            detailId: data.detailId,
            count: data.totalCount
        };
        // set new count value
        detail.spanElement.text(Common.formatCounts(detail.count));
        // reset requestid
        detail.hiddenElement.val(detail.requestId);

        // Clean the status which only used by "NOCOUNTS" situation
        $(detail.hiddenElement).attr('data-count-status-previous', '');
        $(detail.hiddenElement).attr('data-count-status', '');
    }

    private onStatisticsError(data: any): void {
        const detail: CountColumnModel = {
            spanElement: $(`.count_${data.detailId}`),
            hiddenElement: $(`#statisticsRequest${data.detailId}`),
            requestId: -1,
            detailId: data.detailId,
            count: -1
        };
        // set old count value
        const previous: string = detail.spanElement.attr('data-count-previous');
        detail.spanElement.text(previous);
        // reset requestid
        detail.hiddenElement.val(detail.requestId);

        // Put the previous status back if refersh failed
        detail.hiddenElement.attr('data-count-status',
            detail.hiddenElement.attr('data-count-status-previous'));
        detail.hiddenElement.attr('data-count-status-previous', '');
    }

    private onStatisticsCancel(data: any): void {
        const detail: CountColumnModel = {
            spanElement: $(`.count_${data.detailId}`),
            hiddenElement: $(`#statisticsRequest${data.detailId}`),
            requestId: -1,
            detailId: data.detailId,
            count: -1
        };
        // set old count value
        const previous: string = detail.spanElement.attr('data-count-previous');
        detail.spanElement.text(previous);
        // reset requestid
        detail.hiddenElement.val(detail.requestId);
        // Put the previous status back if refersh failed
        detail.hiddenElement.attr('data-count-status',
            detail.hiddenElement.attr('data-count-status-previous'));
        detail.hiddenElement.attr('data-count-status-previous', '');
    }

    private mounted() {
        if (this.UseCacheIfExists && this.SearchResultTableCache == null) {
            // first load filter
            this.searchFilters = this.externalSearchFilters;
            this.InitAudienceSearchTable();
        }
    }

    private openStatisticsPopOver(detailId: number) {
        const target: HTMLElement | null = document.getElementById(`count_${detailId}`);
        const statisticsPanel: any = this.$refs.statisticsPanelRef;
        let requestId: number | null = $(`#statisticsRequest${detailId}`).val();
        if (requestId == null || Number(requestId) < 0) {
            requestId = null;
        }

        // get current status
        const status: string = $(`#statisticsRequest${detailId}`).attr('data-count-status');
        const model: StatisticsPanelModel = new StatisticsPanelModel(
            this.clientId,
            detailId,
            target as HTMLElement,
            requestId,
            status === 'NOCOUNTS');
        statisticsPanel.fetchStatistics(model);
    }

    private InitAudienceSearchTable(): void {
        const that = this;

        if (!that.isSelectable) {
            $('#tableAudienceSearchResult th:nth-child(2)').removeClass('no-show');
        }

        this.audienceSearchTable = $('#tableAudienceSearchResult')
            .on('processing.dt', (e, settings, processing) => {
                // processing ? that.showLoader() : that.hideLoader();
                processing ?
                    Common.blockElement('tableAudienceSearchResult') :
                    Common.unblockElement('tableAudienceSearchResult');
            }).DataTable({
            sDom: 'Rfrt<"row"<"col-md-6"li><"col-md-6"p>>',
            orderMulti: false, // restrict sort to only one column
            serverSide: true,
            searching: false, // disable filter
            // processing: true,
            columns: [
                { name: 'audienceID', data: { _: 'audienceID' } },
                { name: 'Name', data: { _: 'name' } },
                { name: 'tags', data: { _: 'tags' } },
                { name: 'audienceUpdatedByUserID', data: { _: 'audienceUpdatedByUserID' } },
                { name: 'audienceUpdatedOn', data: { _: 'audienceUpdatedOn' } },
                { name: 'audienceCreatedOn', data: { _: 'audienceCreatedOn' } },
                { name: 'isActive', data: { _: 'isActive' } },
                { name: 'countTotal', data: { _: 'countTotal' } },
                { name: 'Actions', data: { _: 'audienceID' } },
                { name: 'description', data: { _: 'description' } },
                { name: 'PropertyNames ', data: { _: 'propertyNames' } },
                { name: 'AssociatedCampaigns', data: { _: 'associatedCampaigns' } }
            ],
            stateSave: true,
            stateSaveCallback: (settings, data) => {
                that.setSearchResultTableStateCache({ data });
            },
            stateLoadCallback: (settings, callback) => {
                if ( that.SearchResultTableCache != null) {
                    callback(that.SearchResultTableStateCache);
                } else {
                    return null;
                }
            },
                ajax: {
                    url: `/api/DataTable/audience/api/v1.0/companyid/${that.clientId}/audience/selected_audience_id/${this.selectedAudienceID}?api_user=${window.eInsightUserEmail}`,
                    type: 'POST',
                    data(data, setting) {
                        that.searchFilters.forEach((filter) => {
                            if ((typeof filter.Value) === 'string') {
                                filter.Value = filter.Value.replace(/&/g, '%26');
                            }
                        });

                    const Filters = that.searchFilters;
                    data.AppendFilter = {
                        Type: 'AudienceSearch',
                        AudienceSearch: Filters
                    };
                    that.setSearchResultTableCache({ data });
                },
                error(xhr) {
                    console.log('AudienceSearchResults => InitAudienceSearchTable => Error Loading data', xhr);
                }
            },
            responsive: {
                // details: false
                details: {
                    renderer(api: any, rowIdx: any, columns: any) {
                        const data = $.map(columns, (col, i) => {
                            return col.hidden ?
                                `<tr data-dt-row="${col.rowIndex}" data-dt-column="${col.columnIndex}">` +
                                `<td class="font-weight-bold">${col.title}</td> ` +
                                `<td class="td-wrap">${col.data}</td>` +
                                `</tr>`
                                : '';
                        }).join('');

                        return data ?
                            $('<table class="table-borderless" />').append(data) :
                            false;
                    }
                }
            },
            lengthMenu: [ [10, 20, 50, 100, 500], [10, 20, 50, 100, 500] ],
            language: {
                lengthMenu: ' _MENU_ entries ',
                sSearch: 'Filter',
                infoFiltered: '',
                // processing: 'Loading...'
            },
            order: [[4, 'desc']],
            columnDefs: [
                { targets: 'no-sort', orderable: false },
                { targets: 'no-show', visible: false },
                { targets: 'text-right-counts', className: 'text-right calc-counts' },
                { targets: 'actions', className: 'actions' },
                {
                    targets: 0,
                    data: 'audienceID',
                    render: (data, type, row, meta) => {
                        if (that.isSelectable) {
                            const audienceRadioButtonCheckedProperty = ((that.selectedAudienceID > 0 && that.selectedAudienceID === data)
                                || (window.componentSelectedAudience && window.componentSelectedAudience === data)) ? 'checked="true"' : '';
                            let title = row.name;
                            if (title.length > 32)
                                title = title.substring(0, 32) + '...';
                            const check = '<label for="' + data + '" class="radio-select"><div class="radio-select-container"></div><input ' + audienceRadioButtonCheckedProperty + ' type="radio" name="selectAudience" id="' + data + '" value="' + data + '" /></label><span>' + title + '</span>';
                            return check;
                        } else {
                            return data;
                        }
                    }
                },
                {
                    targets: 1,
                    data: 'name',
                    render(data, type, row, meta) {
                        return (type === 'display' && data.length > 32) ?
                            ('<span title="' + data + '">' + data.substr(0, 32) + '...</span>')
                            : data;
                    }
                },
                {
                    targets: 2,
                    data: 'tags',
                    render(data, type, row, meta) {
                        return (type === 'display' && data.length > 32) ?
                            ('<span title="' + data + '">' + data.substr(0, 32) + '...</span>')
                            : data;
                    }
                },
                {
                    targets: 3,
                    data: 'audienceUpdatedByUserID',
                    render(data, type, row, meta) {
                        return data;
                    }
                },
                {
                    targets: 4,
                    data: 'audienceUpdatedOn',
                    render(data, type, row, meta) {
                        const date = Common.formatDate(data);
                        const time = Common.formatTime(data);
                        const timezone = systemTimezone();
                        return date + ' ' + time + ' (' + timezone + ')';
                    }
                },
                {
                    targets: 5,
                    data: 'audienceCreatedOn',
                    render(data, type, row, meta) {
                        const date = Common.formatDate(data);
                        const time = Common.formatTime(data);
                        const timezone = systemTimezone();
                        return date + ' ' + time + ' (' + timezone + ')';
                    }
                },
                {
                    targets: 6,
                    data: 'isActive',
                    render(data, type, row, meta) {
                        return data === true ? '<span ><span class="icon-dot active"></span>Active</span>' : '<span><span class="icon-dot"></span>Inactive</span>';
                    }
                },
                {
                    targets: 7,
                    data: 'countTotal',
                    render(data, type, row, meta) {
                        let html = '';
                        const hidden = `<input type="hidden" id="statisticsRequest${row.audienceDetailID}" data-count-status="${row.countStatus}" value="-1">`;
                        if (data === null || data < 0) {
                            if (row.countStatus === 'GENERATING') {
                                html = `<div>${hidden} <span class="count_${row.audienceDetailID}"> Generating </span><a class="counts-trigger" tabindex="0" id="count_${row.audienceDetailID}"><span class="icon-chevron-down"></span></a></div>`;
                            } else {
                                html = `<div>${hidden} <span class="count_${row.audienceDetailID}">—</span><a class="counts-trigger" tabindex="0" id="count_${row.audienceDetailID}"><span class="icon-chevron-down"></span></a></div>`;
                            }
                        } else if (data >= 0) {
                            // TODO: change from audienceCreatedOn to date last run when available ;) don't forget!
                            const date = Common.formatDate(data);
                            const time = Common.formatTime(data);
                            html = `<div>${hidden} <span class="count_${row.audienceDetailID}">${Common.formatCounts(row.countTotal)}</span><a class="counts-trigger" tabindex="0" id="count_${row.audienceDetailID}"><span class="icon-chevron-down"></span></a></div>`;
                        } else {
                            html = `<div> ${hidden} <span class="count_${row.audienceDetailID}"> Generating </span><a class="counts-trigger" tabindex="0" id="count_${row.audienceDetailID}"><span class="icon-chevron-down"></span></a></div>`;
                        }
                        return html;
                    }
                },
                {
                    targets: 8,
                    data: 'audienceID',
                    render(data, type, row, meta) {
                        const html: any = document.getElementById('actionColTemplate');
                        if (html !== null) {
                            const checked: string = row.isActive ? 'checked' : '';
                            // let disabled: string = '';
                            const div: string = html.innerHTML;
                            return div
                                .replace(/#data-detail-id#/g, row.audienceDetailID)
                                .replace(/#data-audience-id#/g, row.audienceID)
                                .replace(/#data-detail-type#/g, row.audienceDetailType)
                                .replace(/#data-row-number#/g, meta.row)
                                .replace(/#data-detail-name#/g, row.name)
                                .replace(/#data-audience-campaigns-count#/g, row.associatedCampaigns ? row.associatedCampaigns.length : 0)
                                .replace(/data-checked="#audience-status-checked#"/g, checked);
                        }
                        return null;
                    }
                },
                {
                    targets: 9,
                    data: 'description',
                    render(data, type, row, meta) {
                        return data;
                    }
                },
                {
                    targets: 10,
                    data: 'propertyNames',
                    render(data, type, row, meta) {
                        return data;
                    }
                }
            ],
            initComplete() {
                $('select[name="tableAudienceSearchResult_length"]').removeClass('custom-select');
            }
        });

        // action dropwown toggle open or close on click
        $('#tableAudienceSearchResult').on('click', '.dropdown-toggle', () => {
            $(this).next().next().toggle();
        });
        // prevent action dropdown from closing
        $('#tableAudienceSearchResult').on('click', '.keep-open', (e) => {
            e.stopPropagation();
        });

        $('#tableAudienceSearchResult').on('click', '.radio-select-container', (e) => {
            const audienceID = e.currentTarget.nextSibling.value;
            window.componentSelectedAudience = audienceID;
            this.submitAudienceSelected(audienceID);
        });

        // Click event for Counts column
        $('#tableAudienceSearchResult tbody').on('click', 'td', function(this: any) {
            if (this.classList.contains('calc-counts')) {
                const cell = that.audienceSearchTable.cell(this);
                const colNumber: number = cell.index().column;
                const colName: string = that.audienceSearchTable.settings().init().columns[colNumber].name;
                // when cell.data() > 0 then not in generating status
                if (colName === 'countTotal') { //  && cell.data() > 0
                    const detailid: any = that.audienceSearchTable.row(this).data().audienceDetailID;
                    that.openStatisticsPopOver(detailid);
                }
            }
        });
        // click event for actions column
        $('#tableAudienceSearchResult tbody').on('click', 'tr td button.results-action', function(this: any) {
            if (this.hasAttribute('data-action') && this.attributes['data-action'].value === 'viewdetails') {
                const audienceid: any = this.attributes['data-audience-id'].value;
                const detailType: any = this.attributes['data-detail-type'].value;
                that.$store.dispatch('manageAudience/setAudienceDetailName',
                    { audienceDetailName: this.attributes['data-detail-name'].value });
                that.$router.push(`audience/${audienceid}/detail/${detailType}`);
            }
        });

        // click action edit, clone functions
        $('#tableAudienceSearchResult tbody').on('click', 'tr td a.dropdown-item', function(this: any) {
            if (this.hasAttribute('data-action')) {
                const audienceid: any = this.attributes['data-audience-id'].value;
                const detailid: any = this.attributes['data-detail-id'].value;
                if (this.attributes['data-action'].value === 'edit') {
                    const detailType: any = this.attributes['data-detail-type'].value;
                    if (detailType === 'LastSaved') {
                        const returnURL = encodeURI(that.$router.currentRoute.fullPath);
                        that.$router.push(
                            `audience/${audienceid}/edit/${detailid}?returnURL=${returnURL}`);
                    } else {
                        that.onEditLastPublished(audienceid, detailid);
                    }
                } else if (this.attributes['data-action'].value === 'clone') {
                    const detailType: any = this.attributes['data-detail-type'].value;
                    that.$router.push(`audience/${audienceid}/clone/${detailType}`);
                }
            }
        });

        $('#tableAudienceSearchResult tbody').on('click', 'tr td input.results-action', function(this: any) {
            if (this.hasAttribute('data-action')) {
                if (this.attributes['data-action'].value === 'updateStatus') {
                    $(this).attr('disabled', true);
                    const audienceid: any = this.attributes['data-audience-id'].value;
                    const rowNumber: number = this.attributes['data-row-number'].value;
                    const newSatatus: boolean = $(this).prop('checked');
                    const audienceName: string = this.attributes['data-audience-name'].value;
                    const campaignsCount: string = this.attributes['data-audience-campaigns-count'].value;

                    const request: any = {
                        audienceId: audienceid,
                        status: newSatatus,
                        rowNumber,
                        campaignsCount
                    };
                    that.activateDeactivateAudienceClicked(request, audienceName);
                }
            }
        });
    }
}
